import { Container } from "reactstrap";
import Footer from "../CommonComponents/Footer";
import Header from "../CommonComponents/Header";
import TapTop from "../CommonComponents/TapTop";
import AboutApplication from "./AboutApplication";
import ExclusiveFeature from "./ExclusiveFeature";
import LandingFooter from "./LandingFooter";
import PricePlan from "./PricePlan";
import SecureApp from "./SecureApp";
import Slider from "./SliderSection";
import Subscribe from "./Subscribe";
import TeamExpert from "./TeamExpert";
import TeamWork from "./TeamWork";
import TemplateFeatures from "./TemplateFeatures";
import Loader from "../../Layout/Loader";
import { Fragment } from "react/jsx-runtime";
import TemplateCustomizer from "../TemplateCustomizer";

const LandingContainer = () => {
  return (
    <Fragment>
      <Loader />
      <div className="index-main">
        <Container fluid className="px-0">
          <div className="landing-page-header">
            <div className="template-landing">
              <Header landing />
              <Slider />
            </div>
          </div>
        </Container>
        <ExclusiveFeature />
        <AboutApplication />
        <TeamWork />
        <TeamExpert />
        <TemplateFeatures />
        <SecureApp />
        <PricePlan />
        <Subscribe />
        <footer className="landing-footer pb-0 section-py-space">
          <LandingFooter />
          <div className="footer">
            <Footer landing />
          </div>
        </footer>
        <TapTop />
      </div>
      <TemplateCustomizer />
    </Fragment>
  );
};

export default LandingContainer;
